import React from 'react'
import { Trash2 } from 'feather-icons-react';


interface IProps {
    usersSelected: { value: string; label: string; error?: string }[]
    onRemoveUser: (user: { value: string; label: string; error?: string }) => void,
    isSelectAllUsers?: boolean,
    
}

const UsersSelected: React.FC<IProps> = ({ usersSelected, onRemoveUser, isSelectAllUsers }) => {
  return (
   <div style={{ width: '100%', height: '300px', overflowY: 'auto', scrollbarWidth: 'thin', scrollbarColor: '#ced4da #f8f9fa' }} className={isSelectAllUsers ? "d-flex align-items-center justify-content-center" : ""}>
    {
        isSelectAllUsers ?
        <div className="d-flex align-items-center justify-content-center" style={{ fontWeight: 'bold', width: '100%', height: '250px', backgroundColor: '#fbf4eb', padding: '10px', borderRadius: '5px' }}>
            All Users Selected
        </div> :
        <table style={{ width: '100%' }} className=" mb-0">
            <tbody>
                {usersSelected.map((user, index) => (
                    <tr key={user.value} style={{ borderBottom: '1px solid #dee2e6' }}>
                        <td style={{ fontWeight: 'bold', width: '20px' }}>{index + 1}</td>
                        <td>
                            <div>
                                <p className='m-0 p-0'>{user.label}</p>
                                {/* {user?.error && <small className="text-danger">ERROR: {user?.error}</small>} */}
                            </div>
                        </td>
                        <td>
                            <button
                                type="button"
                                className="btn btn-soft-danger btn-sm my-1"
                                onClick={(e) => (onRemoveUser(user), e.currentTarget.blur())}
                            >
                                <Trash2 size="16"/>
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    }
   </div>
  )
}

export default UsersSelected
